// extracted by mini-css-extract-plugin
export default {"root":"BlockDefault_root__8lQ7m","media":"BlockDefault_media__Q48A5","text":"BlockDefault_text__uquKZ"};